import React from "react";
import { RoleEditContextProvider } from "./EditRoleView";
import RoleEdit from "./views/EditRoles";

const EditRolePage = () => {
  return (
    <div>
      <RoleEditContextProvider>
        <RoleEdit />
      </RoleEditContextProvider>
    </div>
  );
};

export default EditRolePage;
